export default function Equipment() {
  return (
    <section id="equipment" className="py-16 px-4 bg-gradient-to-b from-white to-cyan-50/30">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold text-center text-gray-900 mb-10">
          使用する機材・洗剤
        </h2>

        <div className="bg-white rounded-2xl p-6 md:p-8 shadow-lg border border-gray-100">
          <div className="space-y-6 text-gray-700 font-normal text-base leading-relaxed text-left">
            <p>
              エアコンクリーニングでは、使用する機材や洗剤によって仕上がりが大きく変わります。当店では、洗浄力と安全性の両立を重視し、機材・洗剤を厳選しています。
            </p>

            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <span className="w-6 h-6 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-checkbox-circle-fill text-cyan-600 text-xl"></i>
                </span>
                <div>
                  <p className="font-bold text-gray-900 mb-1">ケルヒャー製の高圧洗浄機を使用しています。</p>
                  <p className="text-sm text-gray-600 leading-relaxed">
                    以前はエアコンクリーニング専用の高圧洗浄機を使用していましたが、水圧が弱くアルミフィンの奥まで十分に届かない場合がありました。そのため現在は、洗浄力に優れたケルヒャー製の高圧洗浄機を使用しています。内部の汚れまでしっかり洗い流すことができ、洗浄の質を高めながら、作業時間の短縮にもつながっています。
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-3">
                <span className="w-6 h-6 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-checkbox-circle-fill text-cyan-600 text-xl"></i>
                </span>
                <div>
                  <p className="font-bold text-gray-900 mb-1">洗剤には、<strong>「kirei（キレイ）」</strong>を使用しています。</p>
                  <p className="text-sm text-gray-600 leading-relaxed">
                    洗浄力が高く、安全性にも配慮された洗剤で、リンス（すすぎ剤）が不要なのが特長です。アルミフィンやプラスチック製のパーツにも負担が少なく、エアコンを傷めにくい洗浄が可能です。
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-cyan-50 rounded-xl p-4 mt-4">
              <p className="text-sm text-gray-700 leading-relaxed">
                <span className="font-bold text-cyan-700">大切にしていること：</span>
                機材・洗剤ともに、「汚れをしっかり落とすこと」と「エアコンへのやさしさ」の両立を大切にしています。
              </p>
            </div>
          </div>

          {/* 機材・洗剤の写真 */}
          <div className="mt-8">
            <p className="text-sm text-gray-700 font-medium mb-3 text-center">
              ▼ 実際に使用している機材と洗剤はこちらです
            </p>
            <div className="rounded-xl overflow-hidden shadow-md">
              <img
                src="https://static.readdy.ai/image/6095022e0c468d9535f3b012298ccfc9/73c0fedd7b05f6f91eb663aec614ce90.jpeg"
                alt="エアコンクリーニングに使用する機材と洗剤"
                className="w-full h-64 md:h-80 object-contain object-center bg-white"
              />
            </div>
            <p className="text-center text-xs text-gray-500 mt-3">
              実際に使用している機材と洗剤
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
